define('taoQtiItem/qtiItem/core/choices/HotspotChoice',['taoQtiItem/qtiItem/core/choices/Hotspot'], function(QtiHotspot){
    var QtiHotspotChoice = QtiHotspot.extend({
        qtiClass : 'hotspotChoice'
    });
    return QtiHotspotChoice;
});



